import { isRoutePrivate, throttle } from '@/utils';

export interface ITimerService {
  setNewTime: (event: Event) => void;
}

export class TimerService implements ITimerService {
  timerKey = 'timer';
  prevTime = '0';

  private inactivityThreshold;
  private privateRoutes;
  private callback;

  private timer?: ReturnType<typeof setTimeout>;

  constructor(
    inactivityThresholdMinutes: number,
    privateRoutes: Record<string, string> | null,
    callback: () => void,
  ) {
    this.inactivityThreshold = +inactivityThresholdMinutes * 1000 * 60;
    this.privateRoutes = privateRoutes;
    this.callback = callback;

    document.onmousemove = this.throttledResetTimer;
    document.onmousedown = this.throttledResetTimer;
    document.ontouchstart = this.throttledResetTimer;
    document.onclick = this.throttledResetTimer;
    document.onkeydown = this.throttledResetTimer;
    document.addEventListener('scroll', this.throttledResetTimer, true);

    this.resetTimer();
  }

  public setNewTime = (event: Event) => {
    const timerState = localStorage.getItem(this.timerKey) ?? '0';

    if (this.prevTime !== timerState) {
      this.resetTimer(event, true);
      this.prevTime = timerState;
    }
  };

  private resetTimer = (_?: Event, reseted = false, callBack = this.callback) => {
    if (isRoutePrivate(this.privateRoutes)) {
      clearTimeout(this.timer);

      !reseted && localStorage.setItem(this.timerKey, `${Date.now()}`);

      this.timer = setTimeout(() => void callBack(), this.inactivityThreshold);
    }
  };

  private throttledResetTimer = throttle(this.resetTimer, 2000);
}
